'use client';

import { cn } from '@/lib/cn';
import {
  DropdownMenuSeparator,
  type DropdownMenuSeparatorProps,
} from '@heidi/design-system/dropdown-menu';
import * as React from 'react';

import { VariantContext, useIsActivePanel } from './context';

export const AdaptiveMenuSeparator = ({
  className,
  ...props
}: DropdownMenuSeparatorProps) => {
  const variant = React.useContext(VariantContext);
  const isActivePanel = useIsActivePanel();

  if (variant === 'menu') {
    return <DropdownMenuSeparator className={className} {...props} />;
  }
  if (!isActivePanel) return null;
  return <div className={cn('-mx-1 my-1 h-px bg-background-secondary', className)} />;
};
